import { render } from "./EmployeeAssignModal.vue?vue&type=template&id=a4075366"
import script from "./EmployeeAssignModal.vue?vue&type=script&lang=js"
export * from "./EmployeeAssignModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__